import React from 'react';
import { NavLink } from 'react-router-dom';
import './styles/LandingPage.css'; // Ensure the CSS file is inside the src/styles directory
import logo from './Pictures/logo.png'; // Import the logo image
import studentsImage from './Pictures/STUDENT.jpeg'; // Import the students image
import timetableImage from './Pictures/TimeTable.jpeg'; // Import the timetable image
import dashboardImage from './Pictures/Faculty Dashboard.jpeg'; // Import the dashboard image
import messagingImage from './Pictures/Messaging System.jpeg'; // Import the messaging image
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faLinkedin, faTwitter, faYoutube } from '@fortawesome/free-brands-svg-icons';
import { faSignInAlt } from '@fortawesome/free-solid-svg-icons'; // Import the login icon

const recruiters = [
  { name: 'Wipro', logo: 'https://www.kgcas.com/wp-content/uploads/2021/05/wipro-logo.jpg?x28159' },
  { name: 'TCS', logo: 'https://www.kgcas.com/wp-content/uploads/2021/05/tcs-logo.jpg?x28159' },
  { name: 'Infosys', logo: 'https://www.kgcas.com/wp-content/uploads/2021/05/infosys-logo.jpg?x28159' },
  { name: 'Capgemini', logo: 'https://www.kgcas.com/wp-content/uploads/2021/05/capgemini.jpg?x28159' },
  { name: 'Deloitte', logo: 'https://www.kgcas.com/wp-content/uploads/2021/05/deloitte-logo-new.jpg?x28159' },
  { name: 'Cognizant', logo: 'https://www.kgcas.com/wp-content/uploads/2021/05/cts-logo.jpg?x28159' },
  { name: 'IBM', logo: 'https://www.kgcas.com/wp-content/uploads/2021/05/ibm-logo.jpg?x28159' },
  { name: 'KGiSL', logo: 'https://www.kgcas.com/wp-content/uploads/2021/05/kgisl-logo.jpg?x28159' },
  { name: 'Vinsinfo', logo: 'https://www.kgcas.com/wp-content/uploads/2021/05/vinsinfo-logo-1.jpg?x28159' },
  { name: 'Amazon', logo: 'https://www.kgcas.com/wp-content/uploads/2021/05/amazon-logo.jpg?x28159' },
  { name: 'CSS Corp', logo: 'https://www.kgcas.com/wp-content/uploads/2021/05/css-logo.jpg?x28159' },
  { name: 'CG-VAK', logo: 'https://www.kgcas.com/wp-content/uploads/2021/05/cgvak-logo.jpg?x28159' },
  { name: 'Hexaware', logo: 'https://www.kgcas.com/wp-content/uploads/2021/05/hexaware-logo.jpg?x28159' },
  { name: 'IntegraSoft', logo: 'https://www.kgcas.com/wp-content/uploads/2021/05/intefrasoft-logo.jpg?x28159' },
  { name: 'Maveric', logo: 'https://www.kgcas.com/wp-content/uploads/2021/05/maveric-logo.jpg?x28159' },
  { name: 'MRF', logo: 'https://www.kgcas.com/wp-content/uploads/2021/05/mrf-logo.jpg?x28159' },
  { name: 'Syntel', logo: 'https://www.kgcas.com/wp-content/uploads/2021/05/syntel-logo-logo.jpg?x28159' },
  { name: '24/7', logo: 'https://www.kgcas.com/wp-content/uploads/2021/05/24-7-logo.jpg?x28159' },
  { name: 'Atmecs', logo: 'https://www.kgcas.com/wp-content/uploads/2021/05/atmecs-logo.jpg?x28159' },
  { name: 'Zoho', logo: 'https://www.kgcas.com/wp-content/uploads/2023/01/zoho.png?x28159' },
  { name: 'Verticurl', logo: 'https://www.kgcas.com/wp-content/uploads/2023/01/verticurl.png?x28159' },
  { name: 'L&T', logo: 'https://www.kgcas.com/wp-content/uploads/2023/01/lt.png?x28159' },
  { name: 'Cotiviti', logo: 'https://www.kgcas.com/wp-content/uploads/2023/01/cotiviti.png?x28159' },
  { name: 'DHL', logo: 'https://www.kgcas.com/wp-content/uploads/2023/01/dhl.png?x28159' },
  { name: 'Payoda', logo: 'https://www.kgcas.com/wp-content/uploads/2023/01/payoda.png?x28159' },
  { name: 'Ellucian', logo: 'https://www.kgcas.com/wp-content/uploads/2023/01/ellucian.png?x28159' },
  { name: 'Fractal', logo: 'https://www.kgcas.com/wp-content/uploads/2023/01/fractal.png?x28159' },
  { name: 'Kovai', logo: 'https://www.kgcas.com/wp-content/uploads/2021/04/4-kovai.png?x28159' },
  { name: 'Federal Bank', logo: 'https://www.kgcas.com/wp-content/uploads/2021/04/3-fedaral-bank.png?x28159' },
  { name: 'Zifo', logo: 'https://www.kgcas.com/wp-content/uploads/2021/04/2-zifo.png?x28159' },
];

const LandingPage = () => {
  return (
    <div className="landing-page">
      <header className="header">
        <div className="container">
          <div className="logo">
            <img src={logo} alt="Logo" />
          </div>
          <nav className="nav">
            <NavLink to="/login" className="nav-link">
              <FontAwesomeIcon icon={faSignInAlt} className="login-icon" /> Login
            </NavLink>
          </nav>
        </div>
      </header>

      <section className="hero">
        <div className="container">
          <h1>Welcome to the Placement Cell Management System</h1>
          <p>Empowering students and faculty with efficient placement management and training tools.</p>
          <NavLink to="/login" className="cta-button">Get Started</NavLink>
        </div>
      </section>

      <section className="placement-training">
        <div className="container">
          <h2>Placement Training</h2>
          <div className="placement-training-content">
            <div className="placement-vision">
              <img src="https://www.kgcas.com/wp-content/uploads/2021/04/placement-img.jpg?x28159" alt="Placement Training" className="placement-image" />
              <div className="vision-text">
                <h3>Our Vision</h3>
                <p>"To enable the transformation of an individual to become competent in career as well as life skills. We believe in the organic development of skills rather than a crash course that is session based."</p>
              </div>
            </div>
            <div className="placement-details">
              <p>KGiSL – Soft Skills Academy (SSA) was founded in 2013 to cater to the career and life skills development needs of KGiSL – Software division and KGiSL group of educational institutions. Under the vision and leadership of our Managing Director, Dr Ashok Bhakthavatsalam and the Secretary (educational institutions), Dr R Ravichandran, we have found the inspiration to tap our potential further and beyond.</p>
              <p>To hone communication skills at SSA, we categorize our students based on four proficiency levels: Excellent, Proficient, Ideal and Capable, also known as EPIC. Students are trained with the objective of acquiring the Cambridge Business English Certificates (BEC): Preliminary & Vantage, depending on their proficiency levels.</p>
              <p>We train our students to ace interviews and beyond with industry-specific campaign training that involves Quantitative aptitude, Verbal reasoning and Logical reasoning. Keeping pace with the ever evolving trends and requirements of the job industry, we focus on adapting to these trends and incorporating them into our training programs.</p>
            </div>
            <div className="placement-infrastructure">
              <p>One of the primary goals of our Institution is to make the students industry-ready candidates. We assess the Students’ proficiency in Communication Skills and develop the skills required for a job. The Cambridge English language assessments revolve around CEFR level descriptors allow us to encourage students to reflect on their current learning in the setting of objectives and track their progress using level aims, which are matched to the requirement of the industry.</p>
              <p>The purpose of Cambridge Exam Preparation Centre is to imparting English language training to the students and corporate employees in line with Cambridge Assessment English Examinations such as: Key English Test (KET), Cambridge Preliminary English Test (PET) and Cambridge B1 Business English Preliminary & B2 Vantage (BEC) models.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <h2>Features</h2>
          <div className="feature-list">
            <div className="feature-item">
              <img src={studentsImage} alt="Students" />
              <h3>Student Drive Details</h3>
              <p>Track and manage student placement drives with detailed information on rounds and eligibility.</p>
            </div>
            <div className="feature-item">
              <img src={timetableImage} alt="Timetable" />
              <h3>Timetable Management</h3>
              <p>Create and manage timetables for different student groups to ensure effective training sessions.</p>
            </div>
            <div className="feature-item">
              <img src={dashboardImage} alt="Dashboard" />
              <h3>Faculty Dashboard</h3>
              <p>Get insights into student performance and eligibility with interactive charts and reports.</p>
            </div>
            <div className="feature-item">
              <img src={messagingImage} alt="Messaging" />
              <h3>Messaging System</h3>
              <p>Send important messages and updates to students and faculty members with ease.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="placement-officer">
        <div className="container" >
         <div className='txt'> <h2>Placement Officer Details</h2></div>
          <div className="placement-officer-details">
            <div className="officer-image-full">
              <img src="https://www.kgcas.com/wp-content/uploads/2022/11/900473-DR.-PRABHU-T-S-M.SC-SS-250x300.jpg?x28159" alt="Dr. T. S. Prabhu" />
            </div>
            <div className="officer-info">
              <h3>Dr. T. S. Prabhu</h3>
              <p><strong>M.Sc., M.Phil., Ph.D</strong></p>
              <p><strong>Mobile:  +91 975 150 7810 </strong></p>
              <p><strong>Email:  prabhu.s@kgcas.com </strong></p>
            </div>
          </div>
        </div>
      </section>

      <section className="testimonials">
        <div className="container">
          <h2>Testimonials</h2>
          <div className="testimonial-list">
            <div className="testimonial-item">
              <img src="https://www.kgcas.com/wp-content/uploads/2023/10/900691-DR.-BOOPALAN-S-BCA-scaled.jpg?x28159" alt="Dr. Boopalan" />
              <p>"The Placement Training System has streamlined our placement process and improved student engagement."</p>
              <h4>Dr. Boopalan, Technical Training Head</h4>
            </div>
            <div className="testimonial-item">
              <img src="https://www.kgcas.com/wp-content/uploads/2022/11/902559-DR.-MAHARASAN-K-S-BCA-scaled.jpg?x28159" alt="Dr. Maharasan" />
              <p>"I love how easy it is to manage timetables and track student progress with this system."</p>
              <h4>Dr. Maharasan, Faculty Member</h4>
            </div>
          </div>
        </div>
      </section>

      <section className="recruiters">
        <div className="container">
          <h2>Prominent Recruiters</h2>
          <p>KGiSL Institute of Technology (KITE) in Coimbatore has a robust placement record, with students securing positions in various esteemed organizations. Prominent recruiters include major IT firms such as:</p>
          <div className="recruiters-grid">
            {recruiters.map((recruiter, index) => (
              <div key={index} className="recruiter-item">
                <img src={recruiter.logo} alt={recruiter.name} />
              </div>
            ))}
          </div>
          <p>The institute's placement cell actively collaborates with a diverse range of industries to facilitate successful career opportunities for its students.</p>
        </div>
      </section>

      <section className="cta">
        <div className="container">
          <h2>Ready to Get Started?</h2>
          <p>Join us today and take your placement management to the next level.</p>
          <NavLink to="/facultylogin" className="cta-button">Login Now</NavLink>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <p>&copy; 2023 Placement Training System. All rights reserved.</p>
          <p>Developed by Mohammad Razak, BCA 2025 batch</p>
          <div className="social-media">
            <a href="https://www.facebook.com/kgcas" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faFacebook} className="social-icon facebook" />
            </a>
            <a href="https://www.instagram.com/kgcas" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faInstagram} className="social-icon instagram" />
            </a>
            <a href="https://www.linkedin.com/school/kgcas" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faLinkedin} className="social-icon linkedin" />
            </a>
            <a href="https://twitter.com/kgcas" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faTwitter} className="social-icon twitter" />
            </a>
            <a href="https://www.youtube.com/kgcas" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faYoutube} className="social-icon youtube" />
            </a>
          </div>
          <div className="contact-info">
            <p>Contact us</p>
            <p>KGiSL Campus, 365, Thudiyalur Road, Saravanampatti, Coimbatore - 641035.</p>
            <p>Phone: 91-422-441 9999</p>
            <p>Mobile No: +91-96777 26470</p>
            <p>Fax: + 91-422-266 8955</p>
            <p>E-mail: <a href="mailto:2222ja29@kgcas.com">2222ja29@kgcas.com</a></p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingPage;
